import EA from 'helpers/init';

export default EA.Methods.expanderControl = ($this) => {
    const expanders = $this.querySelectorAll('.expander-trigger');

    expanders.forEach((expander) => {
        expander.addEventListener('click', (event) => {
            event.preventDefault();
            const siblings = Array.from(expander.parentElement.parentElement.children);
            if (expander.parentElement.classList.contains('active')) {
                siblings.forEach((sibling) => {
                    sibling.classList.remove('active');
                });
            } else {
                siblings.forEach((sibling) => {
                    sibling.classList.remove('active');
                });
                expander.parentElement.classList.add('active');
            }
        });
    });
};
